import IMask from "imask"

export interface IMaskerOptionsArgs {
  maskType: 'phone' | 'zip'| 'ssn' | 'date' | 'datetime' | 'time' | 'currency' | 'number' | 'percent'
  decimalPlaces?: number
  withCommas?: boolean
}

export function InputMaskerOptions(opts: IMaskerOptionsArgs): IMask.AnyMaskedOptions {
  switch (opts.maskType) {
    case 'phone':
      return {
        mask: "F00-000-0000[ *******************************]",
        definitions: {
          'F': /[2-9]/, // first number of area code cannot start with 0 or 1
        },
      }
    case 'zip':
      return {
        mask: "00000[`-0000]",
      };
    case 'ssn':
      return {
        mask: "000-00-0000",
      }
    case 'date':
      return {
        mask: "`0[0]/`0[0]/`00[00]",
      }
    case 'datetime':
      return {
        mask: "`0[0]/`0[0]/`00[00] `0[0]:`00 AM",
        blocks: {
          AM: {
            mask: IMask.MaskedEnum,
            enum: ["am", "a.m.", "AM", "A.M.", "pm", "p.m.", "PM", "P.M."],
          },
        },
      }
    case 'time':
      return {
        mask: "`0[0]:`00 AM",
        blocks: {
          AM: {
            mask: IMask.MaskedEnum,
            enum: ["am", "a.m.", "AM", "A.M.", "pm", "p.m.", "PM", "P.M."],
          },
        },
      }
    case 'currency':
    case 'number':
    case 'percent': // intentional fall-through
      if (opts.withCommas) {
        return {
          ...commonNumberInputMaskerOptions(opts),
          thousandsSeparator: ',',
        };
      }

      return commonNumberInputMaskerOptions(opts);
    default:
      return { mask: /.*/ };
  }
}

function commonNumberInputMaskerOptions(opts: Pick<IMaskerOptionsArgs, 'decimalPlaces'>): IMask.AnyMaskedOptions {
  return {
    mask: Number,
    signed: true,
    radix: '.',
    mapToRadix: ['.'],
    scale: opts.decimalPlaces,
    padFractionalZeros: opts.decimalPlaces !== 0,
    normalizeZeros: opts.decimalPlaces === 0,
  };
}